<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <heading-view :right-column="show_table_view"></heading-view>

        <add-view v-if="show_add_view" customTable="skola"></add-view>
        <school-table-view v-if="show_table_view"></school-table-view>

        <!--<v-btn fab bottom right dark fixed color="primary" v-if="show_table_view" @click="showAddForm()">-->
            <!--<v-icon>mdi-plus</v-icon>-->
        <!--</v-btn>-->
    </v-container>
</template>

<script>
    import {serverBus} from "../../main";

    import AddView from "../add/AddView";
    import SchoolTableView from '../school/SchoolTableView'
    import HeadingView from '../heading/HeadingView'

    export default {

        components: {
            AddView,
            SchoolTableView,
            HeadingView,
        },

        created: function () {
            let table = 'skola';
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'AddView';
            this.show_table_view = this.$route.matched[0].name === 'SchoolTableView';

            serverBus.$on('show-add-form', (item) => {
                this.$navigate('/admin/' + table + '/add' + (item.id > 0 ? '/' + item.id : ''));
            });
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-add-form', {id: -1});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-add-form');
        },

        data: function () {
            return {
                show_add_view: false,
                show_table_view: false
            };
        }
    }
</script>